const steps = [
  {
    number: '01',
    title: '选择创作模式',
    description: '从多种创作模式中选择——短视频、宣传片、教程视频或社交媒体内容，AI自动推荐最佳模板。',
    icon: 'ri-layout-masonry-line',
  },
  {
    number: '02',
    title: '上传或生成素材',
    description: '上传本地视频、图片和音频，或使用AI生成功能自动创建所需素材，支持所有主流格式。',
    icon: 'ri-upload-cloud-2-line',
  },
  {
    number: '03',
    title: 'AI智能编辑',
    description: 'AI自动完成剪辑、配音、字幕生成和调色，你只需审核和微调即可。',
    icon: 'ri-robot-2-line',
  },
  {
    number: '04',
    title: '一键导出发布',
    description: '选择分辨率和格式，一键导出高质量视频，支持直接发布到各大视频平台。',
    icon: 'ri-send-plane-2-line',
  },
];

export default function HowItWorksSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              四步搞定视频创作
            </h2>
            <p className="text-foreground-600 text-base max-w-2xl mx-auto">
              无需专业背景，无需复杂操作，只需四步即可完成从零到一的视频创作
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((step, index) => (
              <div key={step.number} className="relative">
                <div className="p-6 rounded-lg bg-background-50 border border-background-200/70 h-full">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="text-3xl font-heading font-bold text-primary-200">
                      {step.number}
                    </span>
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                      <i className={`${step.icon} text-lg`}></i>
                    </div>
                  </div>
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                    {step.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                    <i className="ri-arrow-right-s-line text-2xl text-foreground-300"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}